export const evenAnswerChoices = ["F", "G", "H", "J", "K"];
export const oddAnswerChoices = ["A", "B", "C", "D", "E"];
export const answerChoiceOptions = [...oddAnswerChoices, ...evenAnswerChoices];

export const testingTypes = {
  FULL_TEST: "full_test",
  SUBJECT_TEST: "subject_test",
  LESSON_TEST: "lesson_test",
  CHALLENGE: "challenge",
};

export const mockActEventTypes = {
  ONLINE: "online",
  SCHOOL: "school",
  TAKE_HOME: "take_home",
};

export const timingOptions = {
  DEFAULT: "default",
  THREE_HALFS: "1.5x",
  DOUBLE: "2x",
  UNLIMITED: "unlimited",
};

export const testingVariants = {
  CLASSIC: "classic",
  TWENTYTWENTYFIVE: "2025",
  LESSON: "lesson",
};
